<form [formGroup]="searchForm" (ngSubmit)="searchQuestions()">
    <div class="relative w-full flex flex-col gap-4 justify-between bg-blueGray-200 rounded-lg p-4 mb-4">

        <!-- Semantic search text input -->
        @if (showTextFilter) {
        <div class="w-full flex flex-col gap-1">
            <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Semantic text search (searches question meaning)</label>
            <div class="relative flex items-center">
                <i class="fas fa-magic text-indigo-500 absolute left-3"></i>
                <input formControlName="text" type="text"
                    placeholder="e.g. Jesus walking on water, faith in Hebrews"
                    class="w-full !pl-10 pr-3 py-2 text-sm border border-gray-200 rounded-md focus:ring-2 focus:ring-secondary-500 focus:outline-none bg-white">
            </div>
        </div>
        }

        <div class="grid grid-cols-1 gap-4 w-full" [class.sm:grid-cols-2]="showTagsFilter">
            <!-- Bible reference picker -->
            <div class="flex flex-col gap-1">
                <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Bible Reference</label>
                <bible-reference-range-form formControlName="reference" class="w-full"
                    [bibleEnum]="bibleBooks" [verseRequired]="false"
                    [required]="false"></bible-reference-range-form>
            </div>

            <!-- Tags filter -->
            @if (showTagsFilter) {
            <div class="flex flex-col gap-1">
                <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Tags (comma-separated)</label>
                <div class="relative flex items-center">
                    <i class="fas fa-tags text-indigo-500 absolute left-3"></i>
                    <input formControlName="tags" type="text" placeholder="e.g. faith, miracles, grace"
                        class="w-full !pl-10 pr-3 py-2.5 text-sm border border-gray-200 rounded-md focus:ring-2 focus:ring-secondary-500 focus:outline-none bg-white">
                </div>
            </div>
            }
        </div>

        <div class="flex flex-row items-center justify-end gap-3 w-full">
            @if (searchForm.touched && searchForm.invalid) {
            <div class="mr-auto flex items-center gap-1 text-xs text-red-600 tracking-wide">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 20 20"
                    fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                        clip-rule="evenodd" />
                </svg>
                <span>Invalid search fields</span>
            </div>
            }

            <app-btn-action type="button" (clicked)="clearSearch()" [isDisabled]="isLoading"
                bgColor="bg-transparent hover:bg-gray-200/50 disabled:bg-transparent border-0" [shadow]="false"
                textColor="text-gray-500 hover:text-gray-700 disabled:text-gray-300" icon="fas fa-eraser"
                label="Clear"></app-btn-action>

            <app-btn-submit icon="fas fa-search" textColor="text-white" [isLoading]="isLoading"
                [isDisabled]="isLoading || searchForm.invalid"
                bgColor="bg-primary-500 hover:bg-primary-700 disabled:bg-gray-300"
                actionText="Search"></app-btn-submit>
        </div>
    </div>
</form>
